import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

/**
 * This feature reloads Sportsbook when the user stays on the page for a long time
 */
class ReloaderFeature extends AbstractFeature {
    constructor(parent) {
        super(parent);

        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.startTime = Date.now(); // Get the absolute date
    }

    get name() {
        return 'Reloader';
    }

    afterMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    beforeUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    handleVisibilityChange() {
        // reload the page if 2 days passed
        if (document.visibilityState === 'visible' && Date.now() - this.startTime >= 172800000) {
            window.location.reload();
        }
    }
}

new ReloaderFeature(allFeatures);
